import { render, staticRenderFns } from "./account.vue?vue&type=template&id=3de056e4&scoped=true"
import script from "./account.vue?vue&type=script&lang=js"
export * from "./account.vue?vue&type=script&lang=js"
import style0 from "./account.vue?vue&type=style&index=0&id=3de056e4&prod&lang=css"
import style1 from "./account.vue?vue&type=style&index=1&id=3de056e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de056e4",
  null
  
)

export default component.exports